module.exports = __webpack_public_path__ + "assets/img/8.2159eef6.png";